import { Stack, Typography } from "@mui/material";
import type { ReactNode } from "react";

interface IContentPlaceholderProps {
  title: string;
  subtitle: string;
  image: ReactNode;
}

export const ContentPlaceholder = ({ title, subtitle, image }: IContentPlaceholderProps) => {
  return (
    <Stack
      sx={{
        flex: "1 1 auto",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Stack
        sx={{
          gap: 2,
          width: "100%",
        }}
      >
        <Typography
          variant="h2"
          sx={{
            color: "primary.dark",
            fontSize: 24,
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            color: "primary.dark",
          }}
        >
          {subtitle}
        </Typography>
      </Stack>
      <Stack>{image}</Stack>
    </Stack>
  );
};

export * from "./ContentPlaceholderEmptyImage";
